import { consultationApi, useConsultations } from '@entities/consultations';

import { xhr } from '@shared/config';
import { usePopup } from '@shared/hooks';

export const useCancelConsultation = (id: number) => {
	const { setConsultation } = useConsultations();
	const { popup } = usePopup();

	const onCancel = async () => {
		try {
			const res = await xhr.post(`${consultationApi}${id}/cancel/`);

			if (!res.data) throw res;

			setConsultation(res.data);
			popup({ type: 'success', text: 'Консультация отменена' });
		} catch (error) {
			console.log(error);
			popup({ type: 'error', text: 'Не удалось изменить консультацию' });
		}
	};

	return {
		onCancel,
	};
};
